var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroad05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.797,
    height: 108,
    viewBox: "0 0 82.797 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa_2_",
    "data-name": "visa(2)",
    transform: "translate(-6.469 -2.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M87.928,52.518a3.686,3.686,0,0,1-3.675,3.675H10.644a3.686,3.686,0,0,1-3.675-3.675V6.785A3.686,3.686,0,0,1,10.644,3.11h73.61a3.686,3.686,0,0,1,3.675,3.675Z",
    transform: "translate(0.419 0.419)",
    fill: "#eff1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M87.928,81.406a3.686,3.686,0,0,1-3.675,3.675H10.644a3.686,3.686,0,0,1-3.675-3.675V35.675A3.686,3.686,0,0,1,10.644,32h73.61a3.686,3.686,0,0,1,3.675,3.675Z",
    transform: "translate(0.419 24.611)",
    fill: "#eff1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M84.672,57.53H11.062a4.6,4.6,0,0,1-4.593-4.593V7.2A4.6,4.6,0,0,1,11.062,2.61h73.61A4.6,4.6,0,0,1,89.266,7.2V52.936A4.6,4.6,0,0,1,84.672,57.53ZM11.062,4.447A2.759,2.759,0,0,0,8.306,7.2V52.936a2.759,2.759,0,0,0,2.756,2.756h73.61a2.759,2.759,0,0,0,2.756-2.756V7.2a2.759,2.759,0,0,0-2.756-2.756Z",
    transform: "translate(0)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6349",
    "data-name": "Path 6349",
    d: "M84.672,86.418H11.062a4.6,4.6,0,0,1-4.593-4.593V36.093A4.6,4.6,0,0,1,11.062,31.5h73.61a4.6,4.6,0,0,1,4.593,4.593V81.826A4.6,4.6,0,0,1,84.672,86.418ZM11.062,33.337a2.759,2.759,0,0,0-2.756,2.756V81.826a2.759,2.759,0,0,0,2.756,2.756h73.61a2.759,2.759,0,0,0,2.756-2.756V36.093a2.759,2.759,0,0,0-2.756-2.756Z",
    transform: "translate(0 24.192)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6350",
    "data-name": "Path 6350",
    d: "M28.351,51.958A6.654,6.654,0,1,1,21.694,45.3,6.655,6.655,0,0,1,28.351,51.958Z",
    transform: "translate(7.18 35.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6351",
    "data-name": "Path 6351",
    d: "M22.113,59.951a7.573,7.573,0,1,1,7.576-7.574,7.58,7.58,0,0,1-7.576,7.574Zm0-13.308a5.735,5.735,0,1,0,5.738,5.735A5.74,5.74,0,0,0,22.113,46.642Z",
    transform: "translate(6.761 35.334)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M33.246,61.945a10.037,10.037,0,0,0-20.033,0Z",
    transform: "translate(5.647 41.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5279",
    "data-name": "Group 5279",
    transform: "translate(14.636 59.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M33.666,63.283H13.631a.918.918,0,0,1-.917-.978,10.956,10.956,0,0,1,21.867,0,.918.918,0,0,1-.915.978Zm-19-1.837H32.631a9.118,9.118,0,0,0-17.968,0Z",
    transform: "translate(-9.408 -17.721)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M38.475,71.989H11.833a.919.919,0,0,1-.919-.919v-28.5a.919.919,0,0,1,.919-.919H38.475a.919.919,0,0,1,.919.919v28.5a.919.919,0,0,1-.919.919ZM12.751,70.152h24.8V43.489h-24.8Z",
    transform: "translate(-10.914 -26.427)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M30.74,43.4H59.22v1.837H30.74Z",
    transform: "translate(5.688 -24.962)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M30.74,47.377H59.22v1.837H30.74Z",
    transform: "translate(5.688 -21.633)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6357",
    "data-name": "Path 6357",
    d: "M30.74,51.353H59.22V53.19H30.74Z",
    transform: "translate(5.688 -18.304)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M30.74,55.329H59.22v1.837H30.74Z",
    transform: "translate(5.688 -14.974)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("text", {
    id: "VISA",
    transform: "translate(1.771 9)",
    fill: "#f9b316",
    fontSize: 9,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VISA"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M11.081,7.459h33.38V18.636H11.081Z",
    transform: "translate(3.862 4.061)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M0,0H11.177V23.734H0Z",
    transform: "translate(56.795 19.427) rotate(-45)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M42.843,26.456a7.733,7.733,0,1,1-7.732-7.734A7.731,7.731,0,0,1,42.843,26.456Z",
    transform: "translate(17.509 13.492)",
    fill: "#f9dd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M35.53,20.059a6.814,6.814,0,1,0,6.813,6.815,6.823,6.823,0,0,0-6.813-6.815Z",
    transform: "translate(17.09 13.073)",
    fill: "#f9b316"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroad05);
export default __webpack_public_path__ + "static/media/abroad-05.df8492afb999c54e802f9153c16ff479.svg";
export { ForwardRef as ReactComponent };